(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("e7Z1d", function(module, exports) {
const $a4910d2f410975f4$var$init = ()=>{
    const fieldsWrapper = document.querySelectorAll(".f-text, .f-textarea");
    fieldsWrapper.forEach((field)=>{
        const input = field.querySelector(".f-text__input, .f-textarea__input");
        const label = field.querySelector(".f-label");
        if (!input) return;
        const addActive = ()=>{
            label?.classList.add("--active");
            field.classList.add("--active");
        };
        const removeActive = ()=>{
            label?.classList.remove("--active");
            field.classList.remove("--active");
        };
        input.addEventListener("focusout", removeActive);
        input.addEventListener("focus", addActive);
        setTimeout(()=>{
            const isAutofilled = input.matches(":-webkit-autofill") || input.matches(":autofill");
            if (isAutofilled) addActive();
        }, 600);
    });
};
$a4910d2f410975f4$var$init();
document.addEventListener("textfieldReinit", $a4910d2f410975f4$var$init);

});

})();
//# sourceMappingURL=text-field.33c0a68f.js.map
